<template>
  <div class="alert alert-danger alert-dismissible fade show"
    role="alert"
    v-if="errors.length !== 0 && showInPopup === ''+popupOpen"
    variant="danger">
    <div v-for="error in errors" :key="error.id" v-html="error.msg"/>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "ErrorPanel",
  props: ["showInPopup"],
  mounted() {
    // eslint-disable-next-line
    $(document).on('close.bs.alert', () => {
      this.$store.commit("clearErrors");
    });
  },
  methods: {
    clear() {
      this.$store.commit("clearErrors");
    }
  },
  computed: mapState(['errors', 'popupOpen']),
}
</script>

<style scoped>

</style>
